<template>
  <b-form v-on:submit.prevent="submit()" validated novalidate>
    <b-card>
      <div slot="header">
        {{title}}
      </div>
      <b-card-body>
        <b-form-group label-for="Name" label="Name">
          <b-form-input type="text" v-model="adForm.name" class="form-control-warning" id="Name" required></b-form-input>
          <b-form-valid-feedback>
            Valid name provided.
          </b-form-valid-feedback>
          <b-form-invalid-feedback>
            Enter device name.
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label-for="Serial" label="Serial">
          <b-form-input type="text" v-model="adForm.serial" class="form-control-warning" id="Serial" required></b-form-input>
          <b-form-valid-feedback>
            Valid serial provided.
          </b-form-valid-feedback>
          <b-form-invalid-feedback>
            Enter serial.
          </b-form-invalid-feedback>
        </b-form-group>
        <Allocation :adForm="adForm" :hideCompany="hideCompany" :hideDevice="true" :isEdit="isEdit"></Allocation>
        <b-form-group label-for="LandingPage" label="Landing Page">
          <b-form-select id="LandingPage"
                :options="landingPages"
                v-model="form.landingPage" required>
          </b-form-select>              
          <b-form-valid-feedback>
            Valid landing page provided.
          </b-form-valid-feedback>
          <b-form-invalid-feedback>
            Select landing page.
          </b-form-invalid-feedback>
        </b-form-group>
      </b-card-body>
      <div slot="footer" class="text-right">
        <b-button type="submit" size="sm" variant="primary" class="mr-2"><i class="fa fa-dot-circle-o"></i> Submit</b-button>
        <router-link class="btn btn-success btn-sm" :to="{ path: '/admin/devices/list' }"><i class="fa fa-ban"></i> Cancel</router-link>
      </div>
    </b-card>
  </b-form>
</template>
<script>
import axios from 'axios'
import _ from 'lodash'
import filter from './../../../mixins/filter'
import common from './../../../mixins/common'
import Allocation from '@/views/admin/Allocation'

export default {
  name: 'formdevice',
  components: {
    Allocation
  },
  data () {
    return {
      adForm: {},
      branches: []
    }
  },
  mixins: [common,filter],
  props: ['title','form','mode'],
  computed: {
    branchList: function () {
      return this.branches.map((branch) => {
        return {
          text: branch.name,
          value: branch._id
        }
      })
    },
    isEdit: function () {
      return this.mode === 'edit'
    },
    landingPages () {
      let landingPages = _.clone(this.$store.state.landingPages);
      landingPages.push({
        text: 'Inherit from branch',
        value: 'inherit-from-branch'
      });
      return landingPages;
    }
  },
  methods: {
    submit: function () {

      let scope = this; 

      if(!scope.adForm.name) {
        console.log('invalid')
        return
      }
      
      if(!scope.adForm.serial) {
        console.log('invalid')
        return
      }
      
      if(!scope.adForm.branch) {
        console.log('invalid')
        return
      }

      if(!scope.adForm.landingPage) {
        console.log('invalid')
        return
      }

      this.$emit('submit', scope.adForm);
    }
  },
  created () {
    if(!this.isEdit) {
      this.adForm = this.form;
    }
  },
  watch: {
    form (val) {
      this.adForm = this.form;
      if(this.adForm.region === undefined) {
        this.adForm.region = null;
      }
      if(this.adForm.branch === undefined) {
        this.adForm.branch = null;
      }
      if(this.adForm.device === undefined) {
        this.adForm.device = null;
      }
    }
  }
}
</script>
